export default __webpack_public_path__ + "static/image4-4febb6ec5e3c0681d90913b9cb3644b0.jpeg";